<template>
    <div>
        <div style="background-color: white;">
            <van-cell-group>
                <van-cell title="益宝保险理赔信息提交表单" >
                    <div slot="label">请您尽快、准确填写本表单，我们的工作人员会在一个工作日内 联系您，跟进后续理赔事宜</div>
                </van-cell>
            </van-cell-group>
            <van-cell-group>
                <van-field label="出险人姓名" v-model="form.applyName" placeholder="请填写出险人的真实姓名" />
                <van-field label="出险时间"  placeholder="请选择出险时间" @click="showPicker = true" >
                    <div slot="input">{{form.outDate}}</div>
                </van-field>
                <van-cell title="出险情况简述" >
                    <van-field v-model="form.eventDepict" slot="label" type="textarea" placeholder="请简要描述出险人的详细情况" style="padding: 0;" />
                </van-cell>
                <van-field label="出险人手机" type="number" v-model="form.outPhone" placeholder="请填写出险人的手机号码" />
                <van-field label="出险人身份证" v-model="form.applyIdCard" placeholder="请填写出险人身份证号码" />
                <van-field label="联络人姓名" v-model="form.userName" placeholder="如果因特殊情况替出险人申请，请填写联络人姓名" />
                <van-field label="联络人手机" type="number" v-model="form.userPhone" placeholder="请填写代申请人的手机号码" />
            </van-cell-group>
        </div>
        <van-button round type="info" color="linear-gradient(to right, #4587DD, #40B6F8)"
                    style="margin: 30px 10%; width: 80%;"
                    @click="apply">提交信息
        </van-button>

        <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker :formatter="formatter" @cancel="showPicker = false" @confirm="onConfirm"/>
        </van-popup>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {Cell, CellGroup, Field, Image, Popup, Picker, Notify, DatetimePicker, Toast} from 'vant';
    import moment from 'moment';

    Vue.use(Cell).use(CellGroup).use(Field).use(Image).use(Popup).use(Picker).use(Notify).use(DatetimePicker);
    export default {
        name: "ApplyAlaim",
        data() {
            return {
                showPicker: false,
                form: {outDate: moment(Date()).format('YYYY-MM-DD HH:mm')}
            }
        },
        methods: {
            formatter(type, value) {
                if (type === 'year') {
                    return `${value}年`;
                } else if (type === 'month') {
                    return `${value}月`
                }else if (type === 'day') {
                    return `${value}日`
                }
                return value;
            },
            onConfirm(value){
                this.showPicker = false
                let date = moment(value).format('YYYY-MM-DD HH:mm')
                this.$set(this.form,'outDate', date)
            },
            apply() {
                if (!this.form.applyName) {
                    Notify({
                        message: '请填写出险人的真实姓名',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (!this.form.outDate) {
                    Notify({
                        message: '请选择出险时间',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (!this.form.eventDepict) {
                    Notify({
                        message: '请简要描述出险人的详细情况',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (!this.form.outPhone) {
                    Notify({
                        message: '请填写出险人的手机号码',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (!this.form.applyIdCard) {
                    Notify({
                        message: '请填写出险人身份证号码',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (!this.form.userName) {
                    Notify({
                        message: '请填写联络人姓名',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (!this.form.userPhone) {
                    Notify({
                        message: '请填写代申请人的手机号码',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                this.$axios.post("/claim/add", this.form).then(res => {
                    if (res.code == 200) {
                        Toast.success('提交成功')
                        // this.$router.back()
                        this.$router.push('/claimQuery')
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
